import { useState } from "react";
import { socials } from "../constants/socials";
import { toHref } from "./socialLinkHelpers";

// Hover managed in React state, not a CSS :hover rule — each platform's hover
// background/icon color comes from `config`, and Tailwind can't purge-safe a
// class built from a runtime value.
const SocialIcon = ({ id, url, config }) => {
  const [hovered, setHovered] = useState(false);
  const Icon = config.icon;

  return (
    <a
      href={toHref(url)}
      target="_blank"
      rel="noopener noreferrer"
      title={config.label}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={hovered ? { background: config.bg, borderColor: "transparent" } : {}}
      className="flex items-center justify-center h-8 w-8 rounded-lg border border-border-primary bg-background-tertiary transition-all hover:shadow-sm"
    >
      <Icon size={14} aria-label={config.label} style={{ color: hovered ? "#ffffff" : undefined }} className="text-text-faint transition-colors" />
    </a>
  );
};

const SocialRow = ({ socialData }) => {
  if (!socialData) return null;

  const activeLinks = Object.entries(socialData).filter(([, url]) => url);
  if (!activeLinks.length) return null;

  return (
    <div className="shrink-0 px-4 pt-3 pb-3">
      <p className="mb-2 text-[14px] font-semibold text-text-faint">Social</p>
      <div className="flex flex-wrap gap-1.5">
        {activeLinks.map(([id, url]) => {
          const config = socials[id];
          if (!config) return null;
          return <SocialIcon key={id} id={id} url={url} config={config} />;
        })}
      </div>
    </div>
  );
};

export default SocialRow;
